<mat-card *ngIf="isInGroup">
  <mat-card-header>
    <mat-card-title>{{ 'popup.share_study.with_my_group' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-slide-toggle [formControl]="shareWithGroupFormControl">{{ 'popup.share_study.to_my_group' | translate }}</mat-slide-toggle>
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-header>
    <mat-card-title>{{ 'popup.share_study.with_clinics' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-chip-selector
      [filter]="onFilterClinics"
      [label]="'popup.share_study.clinics' | translate"
      [placeholder]="'popup.share_study.new_clinic' | translate"
      (selectItemsChanged)="onSelectedClinicsChanged($event)">
    </app-chip-selector>
  </mat-card-content>
</mat-card>
<mat-card>
  <mat-card-header>
    <mat-card-title>{{ 'popup.share_study.with_users' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-autocomplete-selector
      [label]="'popup.share_study.clinic' | translate"
      [filter]="onFilterClinics"
      (selectItemChanged)="onSelectedUserClinicChanged($event)">
    </app-autocomplete-selector>
    <app-chip-selector
      [filter]="onFilterUsers"
      [label]="'popup.share_study.user' | translate"
      [placeholder]="'popup.share_study.new_user' | translate"
      (selectItemsChanged)="onSelectedUsersChanged($event)">
    </app-chip-selector>
  </mat-card-content>
</mat-card>
